import { makeAutoObservable } from 'mobx';
import { validateMarketOrder } from './validateMarketOrder';

export class MarketOrderData {
  quantityBasisValue = 0;

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach((field) => {
        this[field] = initialData[field];
      });
    }
  }

  //common methods
  resetToDefaults = () => {
    this.quantityBasisValue = 0;
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const data = {
      quantityBasisValue: this.quantityBasisValue,
    };
    const result = validateMarketOrder(data);
    return result;
  };
  returnJson = () => {
    return {
      quantityBasisValue: this.quantityBasisValue,
    };
  };
  //specific methods
  setQuantityBasisValue = (number) => {
    this.quantityBasisValue = number;
  };
}
